import { __decorate, __metadata } from "tslib";
import { AppRequestMethod } from '@core/shared/request';
import { AppRequest } from '@core/shared/app-request';
import { Expose, IsNumber, Model, Type, ModelId } from '@core/shared/model';
import { SceneUserProgressItem } from '../models';
let SceneProgressResponse = /*#__PURE__*/(() => {
  let SceneProgressResponse = class SceneProgressResponse extends Model {};
  __decorate([Expose(), Type(() => SceneUserProgressItem), __metadata("design:type", SceneUserProgressItem)], SceneProgressResponse.prototype, "progress", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], SceneProgressResponse.prototype, "examAdmissionGranted", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], SceneProgressResponse.prototype, "certificateGranted", void 0);
  SceneProgressResponse = __decorate([ModelId("SceneProgressResponse") // auto-generated by generate-model-ids
  ], SceneProgressResponse);
  return SceneProgressResponse;
})();
export { SceneProgressResponse };
let UpdateSceneProgressRequest = /*#__PURE__*/(() => {
  let UpdateSceneProgressRequest = class UpdateSceneProgressRequest extends Model {
    static {
      this.Response = SceneProgressResponse;
    }
  };
  __decorate([IsNumber(), Expose(), __metadata("design:type", Number)], UpdateSceneProgressRequest.prototype, "sceneId", void 0);
  __decorate([IsNumber(), Expose(), __metadata("design:type", Number)], UpdateSceneProgressRequest.prototype, "progress", void 0);
  UpdateSceneProgressRequest = __decorate([AppRequest('courses', 'scenes/progress', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId', 'isLoggedIn']
  }), ModelId("UpdateSceneProgressRequest") // auto-generated by generate-model-ids
  ], UpdateSceneProgressRequest);
  return UpdateSceneProgressRequest;
})();
export { UpdateSceneProgressRequest };